import axios from 'axios';
import { signContractEndpoint } from './endpoints';
import { dataUriToBase64, formatGender } from '../utils/helpers';
import CustomError from '../utils/customError';
import { asyncService } from '../utils/asyncService.js';

const postSignature = async (
  user,
  photosUri,
  pdf,
  notificate,
  allSelfies,
  setError) => {
  try {
    const { front, back } = photosUri;
    if (!(user.cuil || front || back || allSelfies)) {
      console.error('INVALID SINGATURE DATA');
      throw new Error('INVALID SINGATURE DATA');
    }
    const front64 = dataUriToBase64(front);
    const back64 = dataUriToBase64(back);
    const selfie164 = dataUriToBase64(allSelfies.selfie1.photo);
    const selfie264 = dataUriToBase64(allSelfies.selfie2.photo);
    const pdf64 = dataUriToBase64(pdf);

    const formData = new FormData();

    // -- convert base64 to blob
    const base64ToBlob = async (base64, type) => {
      const blob = await fetch(`data:${type};base64,${base64}`);
      return blob
    }
    const res = await base64ToBlob(pdf64, 'application/pdf');
    const blob = await res.blob();
    //--

    formData.append('selfie1', selfie164);
    formData.append('type1', allSelfies.selfie1.type);
    formData.append('selfie2', selfie264);
    formData.append('type2', allSelfies.selfie2.type);
    formData.append('documentFront', front64);
    formData.append('documentBack', back64);
    formData.append('file', blob);
    formData.append('gender', formatGender(user.gender));
    formData.append('cuil', user.cuil);
    formData.append('idType', user.idTypeClient);
    formData.append('metadata', user.metadata);

    const response = await asyncService((params) => axios.post(signContractEndpoint(user.id), formData, {
      headers: {
        Authorization: `Bearer ${user.authorized.jwt.access_token}`
      },
      params,
    }));
    
    notificate.fileId = response.fileId;
    return response;
  } catch (error) {
    console.log('ERROR SIGNING CONTRACT', error);
    if (error.request.status === 401) {
      setError(error)
    } else {
      throw new Error(error);
    };
  }
};

export default postSignature;
